import React from "react";
import {mainService} from "../jwt/_services";

export const mainProvider = {
    getOptions,
};

async function getOptions() {
    try {
        const listItems = await mainService.getVersion();
        listItems.domains.sort((a, b) => a.logicalPropertyName.localeCompare(b.logicalPropertyName));
        return listItems.domains.map((item) => {
            const packageName = item.name.split('.')[0]

            return (
                {
                    id: item.logicalPropertyName,
                    value: packageName + ' . ' + item.logicalPropertyName,
                    label: <label>{ packageName.toUpperCase() + ' . '  } <b>{ item.logicalPropertyName }</b> </label>
                }
            )
        });
    } catch (error) {
        console.log(error.message);
    }
}
